import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

const Modal = ({
  open,
  onClose = () => {},
  children,
  className = "",
  childrenClassName = "",
  showClose = true,
  closeAriaLabel = "Close dialog",
  transformOrigin = "center",
  header,
  footer,
}) => {
  const variants = {
    initial: { opacity: 0, scale: 0, y: 0 },
    animate: { opacity: 1, scale: 1, y: 0 },
    exit: { opacity: 0, scale: 0, y: 0 },
  };
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          key="backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="fixed inset-0 z-[500] bg-black/40 backdrop-blur-sm"
          onClick={(e) => {
            if (e.target === e.currentTarget) onClose();
          }}
        >
          <motion.div
            key="dialogWrapper"
            initial="initial"
            animate="animate"
            exit="exit"
            variants={variants}
            style={{ transformOrigin }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="fixed inset-0 flex items-center justify-center pointer-events-none px-4 py-6"
          >
            <div
              role="dialog"
              aria-modal="true"
              className={`relative w-full max-w-4xl rounded-2xl lg:rounded-[40px] bg-white px-5 lg:px-10 py-8 shadow-[3px_4px_15px_rgba(0,0,0,0.22)] pointer-events-auto ${className}`}
            >
              {showClose && (
                <button
                  aria-label={closeAriaLabel}
                  onClick={onClose}
                  className="absolute right-8 top-4 cursor-pointer"
                >
                  <img
                    src="/assets/svgs/close-icon.svg"
                    alt="close"
                    className="border border-transparent hover:border-black rounded-full"
                  />
                </button>
              )}
              {header}
              <div
                className={`overflow-y-auto max-h-[55vh] modal-scrollbar pr-2 ${childrenClassName}`}
              >
                {children}
              </div>
              {footer}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
